module.exports = __webpack_public_path__ + "img/Not Fully Closing.3b31f5b6.png";